import React from 'react';

interface Props {
  count: number;
}

export default function SelectionCount({ count }: Props) {
  if (count === 0) return null;
  return (
    <span className="text-small">
      <span className="text-weight-bold u-quarter-spacing-right">{count}</span>
      selected
    </span>
  );
}
